import React, { useEffect, useState } from 'react';
import { GrInsecure } from "react-icons/gr";
import { toast } from 'react-toastify';
import Card from 'antd/es/card/Card';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { sendLoginCode, loginWithCode, Reset } from '../../redux/rootSlice';
import Loader from "../../components/Loader";

const LoginWithCode = () => {
  const [loginCode, setLoginCode] = useState("");
  const { email } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [clicked, setClicked] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [isLoggedLoad, setIsLoggedLoad] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  const { isSuccess, isLoggedIn } = useSelector((state) => state.root);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [timeLeft]);

  const handleSendLoginCode = async () => {
    if (!email) {
      toast.error("Email parameter is missing");
      return;
    }
    setIsCodeSent(true);

    const result = await dispatch(sendLoginCode(email));
    setIsCodeSent(false);

    if (sendLoginCode.fulfilled.match(result)) {
      setClicked(true);
      setTimeLeft(5 * 60); // 5 minutes countdown
    } else {
      toast.error("Something went wrong. Please check your network and try again.");
    }
  };

  const handleLoginUserWithCode = async (e) => {
    e.preventDefault();

    if (loginCode === "") {
      return toast.error("Please fill in the login code");
    }
    if (loginCode.length !== 6) {
      return toast.error("Access code must be 6 characters");
    }

    try {
      setIsLoggedLoad(true);
      await dispatch(loginWithCode({ email, loginCode }));
      setIsLoggedLoad(false);
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  useEffect(() => {
    if (isSuccess && isLoggedIn) {
      navigate("/admin");
      toast.success("Login successful!");
    }
  }, [isLoggedIn, isSuccess, navigate]);

  const renderDots = () => {
    return Array(6).fill("").map((_, index) => (
      <span key={index} className="dot w-4 h-4 mx-1 bg-gray-200 rounded-full inline-block">
        {index < loginCode.length && (
          <span className="filled-dot w-4 h-4 bg-blue-600 rounded-full inline-block"></span>
        )}
      </span>
    ));
  };

  const renderTimeLeft = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div className='relative z-10 px-4 md:px-40 text-white '>
      <h1>FTG</h1>
      <Card className="w-full max-w-md mx-auto p-8 ">
        <div className="text-center ">
          <GrInsecure size={35} color="#999" />
          <h2 className="text-2xl font-bold mt-4 font-poppins">Enter Access Code</h2>
          <p className="text-gray-600 mt-2 font-poppins">Check your email for the login access code</p>
        </div>

        <form onSubmit={handleLoginUserWithCode} className="mt-8 space-y-6">
          <div className="flex justify-center space-x-1 mb-4 font-poppins">{renderDots()}</div>
          <input
            type="text"
            placeholder="Access Code"
            required
            name="loginCode"
            value={loginCode}
            onChange={(e) => setLoginCode(e.target.value)}
            maxLength="6"
            pattern="\d*"
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 text-transparent caret-transparent"
            style={{
              WebkitTextSecurity: 'disc',
              MozTextSecurity: 'disc',
              msTextSecurity: 'disc'
            }}
          />

          <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 font-poppins">
            Proceed To Login
          </button>
          {isLoggedLoad && <Loader />}
        </form>

        {timeLeft > 0 && (
          <div className="text-center mt-4 font-poppins">
            <p className="text-red-600">Time left to use code: {renderTimeLeft()}</p>
          </div>
        )}

        <div className="text-center mt-4">
          <p>
            <Link to="/" className="text-blue-600 hover:underline font-poppins">- Home</Link>
          </p>
          <p onClick={handleSendLoginCode} className={` cursor-pointer hover:underline mt-2 font-poppins ${clicked ? "text-red-600": "text-green-600"}`}>
            <b>{clicked ? "Resend" : "Send Code"}</b>
          </p>
          {isCodeSent && <Loader />}
        </div>
      </Card>
    </div>
  );
};

export default LoginWithCode;
